import type { IKeytipProps } from '@fluentui/react/lib/Keytip';

/**
 * Helper function to construct IKeytipProps object
 * @param keytipPrefixSequence Array of prefix sequences that go before this keytip.
 *                             If none (top-level control), then input empty array e.g. []
 *                             Otherwise, input all keytips before this one. e.g. ['e', 'v'].
 *                             *Must be lowercase*
 * @param keytipContent This certain control's keytip. *Must be uppercase*.
 * @param hasMenu Whether this control has a dropdown menu associated with it.
 * @returns IKeytipProps object
 */
export function constructKeytip(
    keytipPrefixSequence: string[],
    keytipContent: string,
    hasMenu?: boolean
): IKeytipProps {
    return {
        content: keytipContent,
        keySequences: [
            ...keytipPrefixSequence.map(keytip => keytip.toLocaleLowerCase()),
            keytipContent.toLocaleLowerCase(),
        ],
        hasMenu,
    };
}
